<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="d-flex align-center">
            <v-col cols="5" sm="5" md="4">
              <v-btn
                small
                :class="
                  $vuetify.breakpoint.xs
                    ? 'white black--text d-print-none mb-3'
                    : 'white black--text d-print-none'
                "
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
              <div
                class="d-flex"
                :class="$vuetify.breakpoint.smAndDown ? 'mt-1' : ''"
              >
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  solo-inverted
                  clearable
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-data-table
          :headers="headers"
          :items="listCasinoBet"
          :label="$t('search')"
          :search="search"
          :items-per-page="10"
          :page.sync="page"
          :no-data-text="$t('noDataFount')"
          :no-results-text="$t('noDataFount')"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
            'items-per-page-options': [
              5,
              10,
              15,
              { text: $t('all'), value: -1 },
            ],
          }"
        >
          <template v-slot:[`footer.page-text`]="items">
            {{ items.pageStart ? items.pageStart : 0 }}
            -
            {{ items.pageStop ? items.pageStop : 0 }}
            {{ $t("of") }}
            {{ items.itemsLength ? items.itemsLength : 0 }}
          </template>

          <template v-slot:[`item.img`]="{ item }">
            <div :class="$vuetify.breakpoint.xs ? 'mt-3' : 'my-3'">
              <div
                v-if="
                  showIconGame.includes(item.game_identifier) ||
                    !item.game_identifier
                "
                class="d-flex justify-center"
              >
                <v-icon large>mdi-image</v-icon>
              </div>
              <div v-else class="d-flex justify-center">
                <v-img
                  v-if="item.game_identifier"
                  max-width="100"
                  :src="src(item.game_identifier)"
                  @error="imgError(item.game_identifier)"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>
            </div>
          </template>

          <template v-slot:[`item.name_game`]="{ item }">
            <div class="text-wrap">
              {{ item.name_game }}
            </div>
          </template>

          <template v-slot:[`item.live`]="{ item }">
            <div>
              {{ getLabelLobby(item.live) }}
            </div>
          </template>

          <template v-slot:[`item.categorie_provider`]="{ item }">
            <div v-if="!item.categorie_provider" class="grey--text">
              {{ $t("noCategory") }}
            </div>
            <div v-else>
              {{ item.categorie_provider }}
            </div>
          </template>

          <template v-slot:[`item.name_provider`]="{ item }">
            <div class="my-3">
              <div v-if="typeHeader === 'provider' && !item.game_identifier">
                {{ item.name_provider }}
              </div>
              <div
                v-else-if="
                  showDefaultImgProvider.includes(item.game_identifier) ||
                    !item.game_identifier
                "
                class="d-flex justify-center d-print-none"
              >
                <v-icon large>mdi-image</v-icon>
              </div>
              <div
                v-else
                class="d-flex justify-center pa-1 d-print-none"
                style="
                  background-color: rgb(223, 223, 223);
                  border-radius: 4px;
                "
              >
                <v-img
                  v-if="item.game_identifier"
                  :width="typeHeader === 'game' ? '64' : '70'"
                  :src="srcProviderImg(item.game_identifier)"
                  @error="imgErrorProvider(item.game_identifier)"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>
            </div>
            <!-- Exibe nome do provider no print ao inves da img -->
            <div
              :class="
                $vuetify.breakpoint.xs
                  ? 'd-none d-print-block'
                  : 'd-none d-print-block pl-2'
              "
            >
              {{ item.name_provider }}
            </div>
          </template>

          <!-- <template v-slot:item.categories="{ item }">
            <div v-if="!$vuetify.breakpoint.xs" class="d-flex flex-column">
              <div
                class="d-print-none"
                v-for="(category, index) in item.categories.slice(0, 2)"
                :key="`${index}-game`"
              >
                <v-chip
                  class="ma-1"
                  small
                  outlined
                  @click="$copy(category)"
                  >
                  {{ category }}
                </v-chip>
              </div>

              <div
                class="d-none d-print-block mx-4"
                v-for="(category, index) in item.categories"
                :key="`${index}-game-print`"
              >
                {{ category }}
              </div>

              <div
                v-if="item.categories.length > 2"
                class="
                  d-flex
                  justify-start
                  my-2
                  d-print-none
                "
              >
                <v-btn
                  text
                  color="primary"
                  x-small
                  @click.prevent="($set(showCategoriesDialog, item.name_game, true), showMore = item.name_game)"
                  >
                  {{ showMore == item.name_game ? $t('showLess') : `${$t('showMore')} (${item.categories.length - 2})` }}
                </v-btn>
              </div>
            </div>
            <span
              v-if="item.categories.length == 0"
              :class="item.description ? '' : 'grey--text'"
            >
              {{$t('noCategory')}}
            </span>
            <v-dialog
              v-else
              v-model="showCategoriesDialog[item.name_game]"
              :key="item.name_game"
              max-width="500"
              :retain-focus="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-show="$vuetify.breakpoint.xs"
                  v-bind="attrs"
                  text
                  color="primary"
                  small
                  v-on="on"
                  @click.prevent="($set(showCategoriesDialog, item.name_game, true), showMore = item.name_game)"
                >
                  {{ $t('view') }} ({{ item.categories.length }})
                </v-btn>
              </template>
              <v-toolbar dense>
                <v-toolbar-title>
                  {{ $t('categories') }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  @click.prevent="($set(showCategoriesDialog, item.name_game, false), showMore = '')"
                >
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-toolbar>
              <v-card class="py-6 px-10">
                <v-row class="d-flex">
                  <div
                    v-for="(category, index) in visibleCategories(item.name_game, item.categories)"
                    class="d-flex align-center"
                    :key="index"
                  >
                    <v-chip
                      class="ma-1"
                      outlined
                      @click="$copy(category)"
                      >
                      {{ category }}
                    </v-chip>
                  </div>
                </v-row>
              </v-card>
            </v-dialog>
          </template> -->

          <template v-slot:[`item.total_bet`]="{ item }">
            <span :class="getColor(item.total_bet)">
              {{ parseFloat(item.total_bet).toFixed(2) }}
            </span>
          </template>

          <template v-slot:[`item.total_prize`]="{ item }">
            <span :class="getColor(item.total_prize)">
              {{ parseFloat(item.total_prize).toFixed(2) }}
            </span>
          </template>

          <template v-slot:[`item.ggr`]="{ item }">
            <span :class="item.ggr > 0 ? 'green--text' : 'red--text'">
              {{ parseFloat(item.ggr).toFixed(2) }}
            </span>
          </template>
        </v-data-table>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="listCasinoBet && listCasinoBet.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("resumeSummary") }}
                <v-icon
                  class="float-right mr-3 d-print-none"
                  @click="$copy(resumePrint)"
                >
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr v-for="item in resume" :key="item.label">
                      <td class="caption">{{ item.label }}</td>
                      <td
                        class="text-right"
                        :class="
                          item.defaultClass
                            ? item.defaultClass
                            : item.classColor
                        "
                      >
                        {{ item.value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "administrator-casino-bet-list-online",
  components: {
    HeaderPrint,
  },
  data: () => ({
    listCasinoBet: [],
    search: "",
    page: 1,
    typeHeader: "game",
    resume: null,
    keysResume: [],
    resumePrint: "",
    showIconGame: [],
    showDefaultImgProvider: [],
    datatableProviderIdentifier: "",
    // Variáveis utilizadas na coluna de Custom Categories
    showMore: "",
    showCategoriesDialog: {},
    categories: [],
  }),

  computed: {
    headers() {
      if (this.typeHeader === "game") {
        return [
          {
            text: this.$t("image"),
            value: "img",
            align: "no-wrap d-print-none",
          },
          {
            text: this.$t("game"),
            value: "name_game",
            align: "no-wrap",
          },
          {
            text: "Lobby",
            value: "live",
            align: "no-wrap",
          },
          {
            text: this.$t("provider"),
            value: "name_provider",
            align: "no-wrap",
          },
          // {
          //   text: this.$t("customCategories"),
          //   value: "categories",
          //   align: "no-wrap"
          // },
          {
            text: this.$t("providerCategories"),
            value: "categorie_provider",
            align: "no-wrap",
          },
          {
            text: this.$t("qtyBets"),
            value: "count_bet",
            align: "no-wrap",
          },
          {
            text: this.$t("betsPrizeQty"),
            value: "count_prize",
            align: "no-wrap",
          },
          {
            text: this.$t("totalBets"),
            value: "total_bet",
            align: "no-wrap",
          },
          {
            text: this.$t("totalPrize"),
            value: "total_prize",
            align: "no-wrap",
          },
          {
            text: "GGR",
            value: "ggr",
            align: "no-wrap",
          },
        ];
      }

      return [
        {
          text: this.$t("provider"),
          value: "name_provider",
          align: "no-wrap",
          width: "100",
        },
        {
          text: this.$t("qtyBets"),
          value: "count_bet",
          align: "no-wrap",
        },
        {
          text: this.$t("betsPrizeQty"),
          value: "count_prize",
          align: "no-wrap",
        },
        {
          text: this.$t("totalBets"),
          value: "total_bet",
          align: "no-wrap",
        },
        {
          text: this.$t("totalPrize"),
          value: "total_prize",
          align: "no-wrap",
        },
        {
          text: "GGR",
          value: "ggr",
          align: "no-wrap",
        },
      ];
    },

    valueColors() {
      return ["total_bet", "total_prize", "ggr"];
    },

    // Retrieve Filters:
    groupByCasino() {
      return this.$store.state.filters.selectCasinoGroupBy.value;
    },

    providerData() {
      return {
        id: this.$store.state.filters.autocompleteProvidersByOperator.id,
        name: this.$store.state.filters.autocompleteProvidersByOperator
          .stringId,
      };
    },

    categoryName() {
      return this.$store.state.filters.autocompleteCasinoCategories.name;
    },

    casinoLobbyType() {
      return this.$store.state.filters.selectCasinoLobby.value;
    },

    casinoVerticalCategory() {
      return this.$store.state.filters.selectCasinoVerticalCategory.value;
    },

    typeBetCasino() {
      return this.$store.state.filters.selectTypeBetCasino.type;
    },

    saveFilters() {
      return this.$store.state.filters.save;
    },

    // Retrieve Range:
    rangeDate() {
      return {
        startDate: this.$store.state.range.date.data_inicio
          .replace("T", " ")
          .slice(0, -4),

        finalDate: this.$store.state.range.date.data_final
          .replace("T", " ")
          .slice(0, -4),
      };
    },

    refresh() {
      return this.$store.getters.getRefresh;
    },
  },

  watch: {
    refresh(val) {
      val && this.getBetsListOnline();
      this.$store.commit("setRefresh", false);
    },

    saveFilters(val) {
      if (!this.groupByCasino) {
        this.$store.commit("setSave", false);
        this.$store.commit("DisabledSave", false);
        this.$store.commit("setFeedbackProgress", false);
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("chooseGroupByOption"),
          color: "warning",
        });
        return;
      }

      val && this.getBetsListOnline();
    },
  },

  methods: {
    async getBetsListOnline() {
      this.typeHeader = this.groupByCasino;
      this.listCasinoBet = [];

      const body = {
        data_inicio: this.rangeDate.startDate,
        data_final: this.rangeDate.finalDate,
        group: this.groupByCasino,
        vertical: this.casinoVerticalCategory,
        provider: this.providerData.id ? this.providerData.id : "",
        categoriasCustomizadas: this.categoryName,
        hasLive: this.casinoLobbyType,
        exempt: this.typeBetCasino,
      };

      this.$request
        .post("administrator/Cassino/Bets/casinoAgregations", body)
        .then((response) => {
          if (Array.isArray(response) && response.length === 0) {
            return;
          }

          // Trata o nome das categorias verticais
          response.dados.forEach((item) => {
            item.total_prize = item.total_prize * -1;

            if (this.groupByCasino === "game") {
              if (item.categorie_provider) {
                item.categorie_provider =
                  item.categorie_provider.charAt(0).toUpperCase() +
                  item.categorie_provider.substring(1);
              } else {
                item.categorie_provider = this.$t("categoryNotFound");
              }
            }
          });

          this.listCasinoBet = response.dados;

          this.buildResume(this.listCasinoBet);
        });
    },

    buildResume(data) {
      // Initial Values
      const sum = [
        {
          label: this.$t("totalBetsAmount"),
          value: 0,
          defaultClass: "white--text darken-4",
        },
        {
          label: this.$t("totalPrizesAmount"),
          value: 0,
          defaultClass: "white--text darken-4",
        },
        { label: this.$t("totalBetsValue"), value: 0 },
        { label: this.$t("totalPrizesValue"), value: 0 },
        { label: "GGR", value: 0 },
      ];

      // Increment
      data.forEach((game) => {
        // Soma QTD Apostas
        sum[0].value += +game.count_bet;
        // Soma QTD Prêmios
        sum[1].value += +game.count_prize;
        // Soma Valor de Apostas
        sum[2].value += +game.total_bet;
        // Soma Valor de Prêmios
        sum[3].value += +game.total_prize;
        // Soma Valor de GGR
        sum[4].value += +game.ggr;
      });

      const complementFormatResume = sum.map((item) => {
        return {
          ...item,
          value:
            item.label == this.$t("totalBetsAmount") ||
            item.label == this.$t("totalPrizesAmount")
              ? item.value
              : item.value.toFixed(2),
          classColor: this.getColor(+item.value),
        };
      });

      this.resume = complementFormatResume;

      this.resumeExcelCopy(complementFormatResume);
    },

    resumeExcelCopy(dataResume) {
      // Essa identação fora do padrão se deve
      // pois quando copiamos e colamos um resumo
      // geralmente o conteúdo colado vem com identação tb
      // Ex.: quando cola os dados numa tabela, ele sempre cai na segunda coluna
      // Mas com essa identação elimina os espaços, tanto acima, como na esquerda
      // Create String with table to Copy on Btn
      let buildBodyCopy = "";
      dataResume.forEach((item) => {
        buildBodyCopy += `<tr>${item.value.toString().replace(".", ",")}</tr>
        `;
      });

      this.resumePrint = `<table>
  ${buildBodyCopy}
</table>`;
    },

    visibleCategories(gameName, categories) {
      if (categories.length == 0) return;
      const visibleCount = this.showMore == gameName ? categories.length : 2;
      return categories.slice(0, visibleCount);
    },

    toggleShowMore(gameName) {
      this.showMore = this.showMore == gameName ? "" : gameName;
    },

    getLabelLobby(value) {
      const labels = {
        0: this.$t("casino"),
        1: this.$t("liveCasino"),
      };
      return labels[value];
    },

    handleColorStatus(status) {
      if (status == 0) return "grey";
      if (status == 1) return "green";
    },

    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },

    src(gameIdentifier) {
      let gameIdentifierSplit = gameIdentifier.split(":");
      const formatSrc = encodeURI(
        `https://cdn.softswiss.net/i/s1/${gameIdentifierSplit[0]}/${gameIdentifierSplit[1]}.png`.replace(
          /\s/g,
          ""
        )
      );
      return formatSrc;
    },

    srcProviderImg(provider_identifier) {
      return `https://cdn.softswiss.net/logos/providers/color/${
        provider_identifier.split(":")[0]
      }.svg`;
    },

    imgError(gameId) {
      this.showIconGame.push(gameId);
    },

    imgErrorProvider(gameId) {
      this.showDefaultImgProvider.push(gameId);
    },
  },
};
</script>
